import React, { useState, useEffect } from "react";
import "../styles/obavijesti.css";
import Header from "./header.js";
import Footer from "./footer.js";
import { FormatiraniTekst, tekstBezOznaka } from "./tekst.js";
import { useSEO } from "./seo.js";

const Obavijesti = ({ obavijesti, loading }) => {
  const [selectedObavijest, setSelectedObavijest] = useState(null);

  useSEO({
    naslov: "Obavijesti - OK Virtus",
    opis: "Novosti Odbojkaškog kluba Virtus: upisi, termini treninga, turniri, kampovi i ostala događanja.",
    putanja: "/obavijesti",
  });

  useEffect(() => {
    if (!selectedObavijest) return;

    const zatvoriNaEscape = (e) => {
      if (e.key === "Escape") setSelectedObavijest(null);
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", zatvoriNaEscape);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", zatvoriNaEscape);
    };
  }, [selectedObavijest]);

  const naTipku = (akcija) => (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      akcija();
    }
  };

  return (
    <div>
      <Header />
      <section id="obavijesti">
        <h2>Obavijesti</h2>
        <div className="news-grid">
          {loading ? (
            <p>Učitavanje obavijesti...</p>
          ) : obavijesti.length > 0 ? (
            obavijesti.map((n, index) => (
              <div
                key={index}
                className="news-card"
                onClick={() => setSelectedObavijest(n)}
                onKeyDown={naTipku(() => setSelectedObavijest(n))}
                role="button"
                tabIndex={0}
              >
                {n.slika && (
                  <div className="news-image">
                    <img
                      src={n.slika}
                      alt={n.naslov}
                      referrerPolicy="no-referrer"
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                )}
                <div className="news-content">
                  <span className="news-date">{n.datum}</span>
                  <h3>{n.naslov}</h3>
                  <p className="line-clamp">{tekstBezOznaka(n.tekst)}</p>
                </div>
              </div>
            ))
          ) : (
            <p>Trenutno nema novih obavijesti.</p>
          )}
        </div>
      </section>

      {selectedObavijest && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedObavijest(null)}
          role="dialog"
          aria-modal="true"
          aria-label={selectedObavijest.naslov}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setSelectedObavijest(null)}
              aria-label="Zatvori obavijest"
            >
              &times;
            </button>

            {selectedObavijest.slika && (
              <img
                src={selectedObavijest.slika}
                alt={selectedObavijest.naslov}
                className="modal-img"
                referrerPolicy="no-referrer"
              />
            )}

            <div className="modal-body">
              <span className="news-date">{selectedObavijest.datum}</span>
              <h2>{selectedObavijest.naslov}</h2>
              <p>
                <FormatiraniTekst tekst={selectedObavijest.tekst} />
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Obavijesti;
